var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4802 0.787897C4.66043 0.607652 4.66043 0.315425 4.4802 0.13518C4.29997 -0.04506 4.00772 -0.04506 3.82749 0.13518L0.13518 3.82749C-0.04506 4.00772 -0.04506 4.29997 0.13518 4.4802L3.82749 8.17251C4.00772 8.35274 4.29997 8.35274 4.4802 8.17251C4.66043 7.99228 4.66043 7.70003 4.4802 7.5198L1.57579 4.61538H11.5385C11.7934 4.61538 12 4.40875 12 4.15385C12 3.89894 11.7934 3.69231 11.5385 3.69231H1.57579L4.4802 0.787897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.15b3ee0bc8b2681de5a49630cf753c81.svg";
export { ForwardRef as ReactComponent };